<ng-container *transloco="let t">
    @if (roleName != specialist) {
    <div class="row">
        <div class="col-md-4 col-sm-6">
            <div class="mb-25">
                <label class="main-label d-block lh-1 text-black">
                    {{t('company')}}
                </label>
                <mat-form-field>
                    <mat-label>
                        {{t('select-company')}}
                    </mat-label>
                    <mat-select [(value)]="selectedCompany" (selectionChange)="changeCompany(selectedCompany)">
                        <mat-option *ngFor="let company of companies" [value]="company.id">
                            {{company.name}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
        <div class="col-md-4 col-sm-6">
            <div class="mb-25">
                <label class="main-label d-block lh-1 text-black">
                    {{t('branch-office')}}
                </label>
                <mat-form-field>
                    <mat-label>
                        {{t('select-branch-office')}}
                    </mat-label>
                    <mat-select [(value)]="selectedBranchOffice"
                        (selectionChange)="changeBranchOffice(selectedBranchOffice)">
                        <mat-option *ngFor="let branchOffice of branchOffices" [value]="branchOffice.id">
                            {{branchOffice.name}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
    </div>
    }
    <div class="row">
        <div class="col-md-12 col-xxxl-6">
            <!-- Tickets Open -->
            <app-tickets-open #kpiViewOpenVulnerabilities></app-tickets-open>
        </div>
        <div class="col-md-12 col-xxxl-6">
            <!-- Tickets In Progress -->
            <app-tickets-in-progress #kpiViewAllOpenVulnerabilitiesWithoutManagement></app-tickets-in-progress>
        </div>
        <div class="col-md-12 col-xxxl-6">
            <!-- Tickets Resolved -->
            <app-tickets-resolved #kpiViewAllVulnerabilities></app-tickets-resolved>
        </div>
        <div class="col-md-12 col-xxxl-6">
            <!-- Tickets Closed -->
            <app-tickets-closed #kpiViewAllClosedVulnerabilities></app-tickets-closed>
        </div>
        <div class="col-md-12 col-xxxl-6">
            <!-- New Tickets Created -->
            <app-new-tickets-created #kpiVulnerabilitiesByCriticality></app-new-tickets-created>
        </div>
        <div class="col-md-12 col-xxxl-6">
            <!-- Tickets Solved and Created -->
            <app-tickets-solved-and-cleated #multipleKpiSeriesVulnerabilityVersus></app-tickets-solved-and-cleated>
        </div>
        @if (roleName != specialist) {
        <div class="col-lg-12">
            <!-- Performance of Agents -->
            <app-performance-of-agents #tableVulnerabilityAssessmentBySupervisorAndSeverity></app-performance-of-agents>
        </div>
        }
        <div class="col-lg-6 col-xxxl-3">
            <!-- Customer Satisfaction -->
            <app-customer-satisfaction #pieVulnerabilitiesBySeverityLevel></app-customer-satisfaction>
        </div>
        <div class="col-md-6 col-xxxl-3">
            <!-- Tickets by Channel -->
            <app-tickets-by-channel #pieVulnerabilitiesOpenBySeverityLevel></app-tickets-by-channel>
        </div>
        <div class="col-md-6 col-xxxl-3">
            <!-- Tickets by Type -->
            <app-tickets-by-type #pieVulnerabilitiesClosedBySeverityLevel></app-tickets-by-type>
        </div>
    </div>
</ng-container>
